import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  inputClasses,
  inputLabelClasses,
} from "@mui/material";
import { Col, Row } from "react-bootstrap";
import Home from "../home/Home";
import FundRqst_service from "../../Services/FundRqst_service";
import Snackbar from "../Snacbar";
import { getUserId } from "../Utils/Common";
import FileSaver from "file-saver";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router";
import { ToggleButton } from "@mui/material";

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {},
  },
});
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item1 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item2 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'right',
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    backgroundColor: "rgb(61, 195, 177)",
    padding: theme.spacing(0.5),
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
}));

function FundSecLevelVerification() {
  // BE NO specific controls
  const [BeNoHidden, setBeNoHidden] = useState(true);
  const [BeNoSearchHidden, setBeNoSearchHidden] = useState(true);
  const [beNoValue, setBeNoValue] = useState("");
  const [searchPros, setsearchPros] = useState(false);

  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");
  const [status, setstatus] = useState("");
  const [fundstatusdrp, setfundstatusdrp] = useState([]);
  const [Vendordrp, setVendordrp] = useState([]);
  const [PaymentModedrp, setPaymentModedrp] = useState([]);
  const [Fund2ndLvlvrfyvalues, setFund2ndLvlvrfyvalues] = useState({
    cmid: "",
    purpose_pmtid: "",
    purpose_reqpurid: "",
    purposeSummary_id: "",

    Reqamt: "",
    Aprvlamt: "",
    FirstLvlamt: "",

    fundstatus: "",
    jobNo: "",
    vendorType: "",
    secLvlAmt: "",
    paymentMode: "",
    secLevlRmks: "",
  });

  ///Handle Change=>>
  const SecLevelFundStatusHandleChange = (e) => {
    const value = e.target.value;

    // reset common states
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setsecLvlDetails([]);
    setsecLvlDetails2([]);
    setsecLvlDetails3([]);
    setsecLvlDetails4([]);
    setsecLvlDetails5([]);

    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      fundstatus: value,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlAmt: "",
      paymentMode: "",
      secLevlRmks: "",
      vendorType: "",
      jobNo: "",
    });

    // hide BE NO controls by default
    setBeNoHidden(true);
    setBeNoSearchHidden(true);

    // ✅ special case: BE NO
    if (value === "BE NO") {
      setBeNoHidden(false);
      setBeNoSearchHidden(false);

      SetVendorHidden(true);
      SetJobHidden(true);
      setdesignHidden(true);
      settablehidden(true);
      setsearchbtnhidden(true);

      return; // stop here for BE NO
    }

    // old logic preserved
    if (value === "JOB") {
      setstatus(1);
    } else if (value === "VENDOR") {
      setstatus(2);
    } else if (value === "MISCELLANEOUS") {
      setstatus(3);
    } else if (value === "CLIENT") {
      setstatus(4);
    }

    let consignmentNumber = "-1";
    if (value === "JOB") {
      consignmentNumber = Fund2ndLvlvrfyvalues.jobNo || "-1";
    } else {
      consignmentNumber = Fund2ndLvlvrfyvalues.vendorType || "-1";
    }

    const details = { consignmentNumber, status: "4", requestStatus: value };

    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setsecLvlDetails(res.data);
      setFilteredDetails(res.data);
    });

    FundRqst_service.getPaymentJobNo(details).then((res) => {
      setsecLvlDetails4(res.data);
      setFilteredDetails2(res.data);
    });

    FundRqst_service.getBillPaymentType().then((res) =>
      setPaymentModedrp(res.data)
    );

    if (value === "JOB") {
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(false);
    } else if (["VENDOR", "MISCELLANEOUS", "CLIENT"].includes(value)) {
      FundRqst_service.getVendorType(value).then((res) =>
        setVendordrp(res.data)
      );
      SetVendorHidden(false);
      SetJobHidden(true);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(true);
    } else if (value === "") {
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(true);
      settablehidden(true);
      setsearchbtnhidden(false);
    }
  };
  const handleBeNoSearch = async () => {
    const beNo = beNoValue && beNoValue.trim();
    if (!beNo) {
      setMessage("Please enter BE No before searching!");
      setseverit("warning");
      setOpen(true);
      return;
    }

    setsearchPros(true);

    try {
      // 1️⃣ get consignment numbers for BE NO
      const beNoPayload = {
        consignmentNumber: beNo,
        status: "4",
        requestStatus: "BE NO",
      };
      const [nonJobRes, jobRes] = await Promise.all([
        FundRqst_service.getPaymentNonJobNo(beNoPayload),
        FundRqst_service.getPaymentJobNo(beNoPayload),
      ]);

      const beNoData = [...(nonJobRes?.data || []), ...(jobRes?.data || [])];
      const consignmentNumbers = [
        ...new Set(beNoData.map((d) => d.consignmentNumber).filter(Boolean)),
      ];

      if (consignmentNumbers.length === 0) {
        setMessage("No consignment numbers found for this BE No!");
        setseverit("info");
        setOpen(true);
        setsearchPros(false);
        return;
      }

      // 2️⃣ fetch JOB data for those consignment numbers
      const jobRequests = consignmentNumbers.map((cno) => {
        const jobPayload = {
          consignmentNumber: cno,
          status: "4",
          requestStatus: "JOB",
        };
        return Promise.all([
          FundRqst_service.getPaymentNonJobNo(jobPayload),
          FundRqst_service.getPaymentJobNo(jobPayload),
        ]);
      });

      const responses = await Promise.all(jobRequests);
      const allNonJob = [];
      const allJob = [];

      responses.forEach(([nonJob, job]) => {
        if (nonJob?.data) allNonJob.push(...nonJob.data);
        if (job?.data) allJob.push(...job.data);
      });

      // 3️⃣ update your tables (only JOB data)
      setsecLvlDetails(allNonJob);
      setFilteredDetails(allNonJob);
      setsecLvlDetails4(allJob);
      setFilteredDetails2(allJob);

      setBeNoHidden(true);
      setBeNoSearchHidden(true);
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(false);

      // ✅ Update Fund Status dropdown value
      setFund2ndLvlvrfyvalues((prev) => ({
        ...prev,
        fundstatus: "JOB",
      }));

      // ✅ Optional success feedback
      setMessage("BE No search completed — switched to JOB mode");
      setseverit("success");
      setOpen(true);
    } catch (err) {
      setMessage(err.message || "Error fetching BE NO details");
      setseverit("error");
      setOpen(true);
    } finally {
      setsearchPros(false);
    }
  };

  const SecLvl_jobNoHandleChange = (e) => {
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const SecLvl_vendortypHandleChange = (e) => {
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      vendorType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
    let details = {
      consignmentNumber: e.target.value,
      status: "4",
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setsecLvlDetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: e.target.value,
      status: "4",
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setsecLvlDetails4(res.data);
      setFilteredDetails2(res.data);
    });
  };
  const SecLvl_amtHandleChange = (e) => {
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      secLvlAmt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const SecLvl_paymntmdHandleChange = (e) => {
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      paymentMode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const SecLvl_RmksHandleChange = (e) => {
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      secLevlRmks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const FundStsName = () => {
    if (status === 1) {
      return "Job No";
    } else if (status === 2) {
      return "VENDOR";
    } else if (status === 3) {
      return "MISCELLANEOUS";
    } else if (status === 4) {
      return "CLIENT";
    }
  };
  ///keydown
  const jobkeydown = (e) => {
    if (e.key === "Enter") {
      jobSearchBtn();
    }
  };
  const fund2ndlvlKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("paymentmode").focus();
    }
  };
  const paymentMdkeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("rmks").focus();
    }
  };
  ///hidden
  const [designHidden, setdesignHidden] = useState(true);
  const [tablehidden, settablehidden] = useState(true);
  const [VendorHidden, SetVendorHidden] = useState(true);
  const [JobHidden, SetJobHidden] = useState(false);
  const [searchbtnhidden, setsearchbtnhidden] = useState(true);

  const [secLvlDetails, setsecLvlDetails] = useState([]);
  const [secLvlDetails2, setsecLvlDetails2] = useState([]);
  const [secLvlDetails3, setsecLvlDetails3] = useState([]);
  const [secLvlDetails4, setsecLvlDetails4] = useState([]);
  const [secLvlDetails5, setsecLvlDetails5] = useState([]);
  // const [paymentcopydetails, setpaymentcopydetails] = useState([]);

  const [verifyDis, setverifyDis] = useState(true);
  const [updateDis, setupdateDis] = useState(true);
  const [NonverifyDis, setNonverifyDis] = useState(true);
  const [DownldRqstDis, setDownldRqstDis] = useState(true);

  ///processing
  const [verifyProcs, setverifyProcs] = useState(false);
  const [updateProcs, setupdateProcs] = useState(false);
  const [NonVerifyProcs, setNonVerifyProcs] = useState(false);
  const [dwnldRqCopyProcs, setdwnldRqCopyProcs] = useState(false);
  const [RefreshProcs, setRefreshProcs] = useState(false);
  //
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [FilteredDetails2, setFilteredDetails2] = useState([]);
  ///resetall
  const resetalloperation = () => {
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlAmt: "",
      paymentMode: "",
      secLevlRmks: "",
    });
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setsecLvlDetails([]);
    setsecLvlDetails2([]);
    setsecLvlDetails3([]);
    setsecLvlDetails4([]);
    setsecLvlDetails5([]);
    setverifyProcs(false);
    setupdateProcs(false);
    setNonVerifyProcs(false);
    setdwnldRqCopyProcs(false);
    setRefreshProcs(false);
    setverifyDis(true);
    setupdateDis(true);
    setNonverifyDis(true);
    setDownldRqstDis(true);
    Getpaymentjob_nonjob_no();
  };
  ///validation
  const SecLevelValidation = () => {
    if (Fund2ndLvlvrfyvalues.secLvlAmt !== "") {
      if (Fund2ndLvlvrfyvalues.paymentMode !== "") {
        return true;
      } else {
        setMessage("Please Select Payment Mode ,Warning ..!!");
        setseverit("warning");
        setOpen(true);
        document.getElementById("paymentmode").focus();
      }
    } else {
      setMessage("Please Enter Payment Request Amount ,Warning ..!!");
      setseverit("warning");
      setOpen(true);
      document.getElementById("2ndlvlamt").focus();
    }
    return false;
  };

  /////searchBTN===========>
  const jobSearchBtn = () => {
    setverifyDis(true);
    setupdateDis(true);
    setNonverifyDis(true);
    setDownldRqstDis(true);
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlAmt: "",
      paymentMode: "",
      secLevlRmks: "",
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
    });
    setsecLvlDetails2([]);
    setsecLvlDetails3([]);
    Getpaymentjob_nonjob_no();
  };
  const [selected, setSelected] = useState([]);
  const [selected1, setSelected1] = useState([]);
  //gettable2=========>
  const getnonpurpose = (trns) => {
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);
    setsecLvlDetails2([]);
    setsecLvlDetails5([]);
    setverifyDis(true);
    setupdateDis(true);
    setNonverifyDis(true);
    setDownldRqstDis(true);
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      cmid: trns.cmId,
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlAmt: "",
      paymentMode: "",
      secLevlRmks: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
    });
    let details = {
      cmId: trns.cmId,
      status: "4",
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setsecLvlDetails2(res.data);
    });
    let details2 = {
      paymentId: trns.cmId,
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setsecLvlDetails5(res.data);
    });
    setsecLvlDetails3([]);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  ///
  ///getable3==============>
  const getpurpose = (trns) => {
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);
    setsecLvlDetails3([]);
    setsecLvlDetails5([]);
    setverifyDis(true);
    setupdateDis(true);
    setNonverifyDis(true);
    setDownldRqstDis(true);
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      cmid: trns.cmId,
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlAmt: "",
      paymentMode: "",
      secLevlRmks: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
    });
    let details = {
      cmId: trns.cmId,
      status: "8",
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setsecLvlDetails3(res.data);
      console.log("PAY ID ==>" + JSON.stringify(res.data));
    });
    let details2 = {
      paymentId: trns.cmId,
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setsecLvlDetails5(res.data);
    });
    setsecLvlDetails2([]);
  };
  const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
  /////
  ///tableclickprocess========>
  const nonverifypurpose = (trns) => {
    const selectedIndex = selected1.indexOf(trns.reqAmount);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected1, trns.reqAmount);
    }
    setSelected1(newSelected);
    setsecLvlDetails3([]);
    setverifyDis(false);
    setupdateDis(true);
    setNonverifyDis(true);
    setDownldRqstDis(false);
    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 1);

    // let details = { cmId: Fund2ndLvlvrfyvalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
    // FundRqst_service.getPaymentCopy(details).then(res => {
    //     setpaymentcopydetails(res.data);
    // })
  };
  const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
  ///
  const verifypurpose = (trns) => {
    const selectedIndex = selected1.indexOf(trns.reqAmount);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected1, trns.reqAmount);
    }
    setSelected1(newSelected);
    setsecLvlDetails2([]);
    setverifyDis(true);
    setupdateDis(false);
    setNonverifyDis(false);
    setDownldRqstDis(false);
    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 2);

    // let details = { cmId: Fund2ndLvlvrfyvalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
    // FundRqst_service.getPaymentCopy(details).then(res => {
    //     setpaymentcopydetails(res.data);
    // })
  };
  const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
  ////getfundstatues=======>
  const FundStatusDropdown = async () => {
    FundRqst_service.getFundStatus().then((res) => {
      setfundstatusdrp(res.data);
    });
  };
  /////
  const Getpaymentjob_nonjob_no = () => {
    var consignmentNumber = "";
    if (Fund2ndLvlvrfyvalues.fundstatus === "JOB") {
      if (Fund2ndLvlvrfyvalues.jobNo === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = Fund2ndLvlvrfyvalues.jobNo;
      }
    } else if (Fund2ndLvlvrfyvalues.fundstatus !== "JOB") {
      if (Fund2ndLvlvrfyvalues.vendorType === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = Fund2ndLvlvrfyvalues.vendorType;
      }
    }
    let details = {
      consignmentNumber: consignmentNumber,
      status: "4",
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setsecLvlDetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: consignmentNumber,
      status: "4",
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setsecLvlDetails4(res.data);
      setFilteredDetails2(res.data);
    });
  };
  ///getFirtLvlvrfyAssign====>
  const getpaymentdetailsAssign = (payid, reqid, val) => {
    let details = { paymentId: payid };
    FundRqst_service.getPaymentDetails(details)
      .then((res) => {
        const data = res.data;
        const details = data.map((trns) => trns);
        var txt_amount,
          secondMode,
          appRemarks = "";
        if (val === 1) {
          txt_amount = details[0].firstLevelAmount;
        } else {
          txt_amount = details[0].secondLevelAmount;
        }
        if (
          details[0].appMode === null ||
          details[0].appMode === "" ||
          !details[0].appMode
        ) {
          secondMode = "";
        } else {
          secondMode = details[0].appMode;
        }
        if (
          details[0].appRemarks === null ||
          details[0].appRemarks === "" ||
          !details[0].appRemarks
        ) {
          appRemarks = "";
        } else {
          appRemarks = details[0].appRemarks;
        }
        setFund2ndLvlvrfyvalues({
          ...Fund2ndLvlvrfyvalues,
          Reqamt: details[0].reqAmount,
          Aprvlamt: details[0].approvalAmunt,
          FirstLvlamt: details[0].firstLevelAmount,
          secLvlAmt: txt_amount,
          secLevlRmks: appRemarks,
          paymentMode: secondMode,
          purpose_pmtid: payid,
          purpose_reqpurid: reqid,
        });
      })
      .catch((error) => {
        setMessage(error.message);
        setseverit("error");
        setOpen(true);
      });
  };
  ///buttonFunctions=========>
  const verify_update_operations = () => {
    if (SecLevelValidation() === true) {
      let details = {
        cmId: Fund2ndLvlvrfyvalues.purpose_pmtid,
        reqAmount: null,
        reqPurpose: null,
        reqPaidTo: null,
        reqDate: null,
        reqBy: null,
        approvalAmunt: null,
        approvalDate: null,
        approvalBy: null,
        firstLevelAmount: null,
        firstLevelDate: null,
        firstVeryBy: null,
        secondLevelAmount: Fund2ndLvlvrfyvalues.secLvlAmt,
        secondLevelDate: null,
        secondVeryBy: getUserId(),
        allocatedAmount: null,
        allocatedMode: Fund2ndLvlvrfyvalues.paymentMode,
        allocatedVoucherNo: null,
        allocatedVoucherType: null,
        allocatedVocherCopy: null,
        allocatedPrintedBy: null,
        allocatedDate: null,
        allocatedBy: null,
        status: "4",
        remarks: Fund2ndLvlvrfyvalues.secLevlRmks,
        referenceNo: null,
        bankName: null,
        accountNo: null,
        ifsc: null,
        benName: null,
        gstinPayee: null,
        requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
        refundStatus: null,
      };
      FundRqst_service.updatePaymentDetails(details)
        .then((res) => {
          const message = res.data.message;
          if (message.toString() === "SUCCESS") {
            setMessage("Verified Successfully");
            setseverit("success");
            setOpen(true);
            resetalloperation();
          } else {
            setMessage("Verification Failed " + message.toString());
            setseverit("error");
            setOpen(true);
          }
        })
        .catch((error) => {
          setMessage("Verification Failed " + error.message);
          setseverit("error");
          setOpen(true);
        });
    }
  };
  const verifyBtn = () => {
    setverifyProcs(true);
    verify_update_operations();
    setverifyProcs(false);
  };
  const updateBtn = () => {
    setupdateProcs(true);
    verify_update_operations();
    setupdateProcs(false);
  };
  const NonverifyBtn = () => {
    setNonVerifyProcs(true);
    let details = {
      cmId: Fund2ndLvlvrfyvalues.cmid,
      paymentId: Fund2ndLvlvrfyvalues.purpose_pmtid,
      status: "4",
      createdBy: getUserId(),
      requestStatus: Fund2ndLvlvrfyvalues.fundstatus,
    };
    FundRqst_service.updatePaymentStatus(details)
      .then((res) => {
        const message = res.data.message;
        if (message.toString() === "SUCCESS") {
          setMessage("Non-Verified Successfully");
          setseverit("success");
          setOpen(true);
          resetalloperation();
        } else {
          setMessage("Verification Failed..!!" + message.toString());
          setseverit("error");
          setOpen(true);
          document.getElementById("2ndlvlamt").focus();
        }
      })
      .catch((error) => {
        setMessage("Verification Failed " + error.message);
        setseverit("error");
        setOpen(true);
      });
    setNonVerifyProcs(false);
  };
  const saveimage = () => {
    setdwnldRqCopyProcs(true);
    let details = {
      cmId: Fund2ndLvlvrfyvalues.cmid,
      reqPurpose: Fund2ndLvlvrfyvalues.purpose_reqpurid,
      status: "1",
    };
    FundRqst_service.getPaymentCopy(details)
      .then((res) => {
        const data = res.data;
        const detaill = data.map((node) => node.docImage);
        // console.log('before saveAs '+JSON.stringify(detaill.toString()))
        // FileSaver.saveAs(`data:image/jpeg;base64,${detaill.toString()}`, Fund2ndLvlvrfyvalues.cmid + "-" + Fund2ndLvlvrfyvalues.purpose_reqpurid + ".jpg");
        const filedata = detaill.toString();
        const formates = filedata.split("/9j/4");
        //    console.log('ggg '+JSON.stringify(formates))
        if (formates[0] === "") {
          FileSaver.saveAs(
            `data:image/jpg;base64,${detaill.toString()}`,
            Fund2ndLvlvrfyvalues.cmid +
              "-" +
              Fund2ndLvlvrfyvalues.purpose_reqpurid +
              ".jpg"
          );
        } else {
          const Pngformates = filedata.split("iVBORw0KGg");
          if (Pngformates[0] === "") {
            FileSaver.saveAs(
              `data:image/jpg;base64,${detaill.toString()}`,
              Fund2ndLvlvrfyvalues.cmid +
                "-" +
                Fund2ndLvlvrfyvalues.purpose_reqpurid +
                ".jpg"
            );
          } else {
            FileSaver.saveAs(
              `data:application/pdf;base64,${detaill.toString()}`,
              Fund2ndLvlvrfyvalues.cmid +
                "-" +
                Fund2ndLvlvrfyvalues.purpose_reqpurid +
                ".pdf"
            );
          }
        }
        setdwnldRqCopyProcs(false);
      })
      .catch((error) => {
        setMessage("Insertion Failed! ," + error.message);
        setseverit("error");
        setOpen(true);
        setdwnldRqCopyProcs(false);
      });
    // FileSaver.saveAs(lastresult[0].docImage, Fund2ndLvlvrfyvalues.cmid + "-" + Fund2ndLvlvrfyvalues.purpose_reqpurid + ".pdf")
    // setdwnldRqCopyProcs(false)
  };
  const RefreshBtn = () => {
    setRefreshProcs(true);
    setFund2ndLvlvrfyvalues({
      ...Fund2ndLvlvrfyvalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlAmt: "",
      paymentMode: "",
      secLevlRmks: "",
      fundstatus: "JOB",
      jobNo: "",
      vendorType: "",
    });
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setsecLvlDetails([]);
    setsecLvlDetails2([]);
    setsecLvlDetails3([]);
    setsecLvlDetails4([]);
    Getpaymentjob_nonjob_no();
    setverifyDis(true);
    setupdateDis(true);
    setNonverifyDis(true);
    setDownldRqstDis(true);
    document.getElementById("fundstatus").focus();
    setRefreshProcs(false);
  };
  //table search
  const fundSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fundOnchange(e.target.value);
        }}
      />
    );
  };
  const fundOnchange = (searchedVal) => {
    const filteredvalue = secLvlDetails.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails(secLvlDetails);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const fundSrch2 = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fund2Onchange(e.target.value);
        }}
      />
    );
  };
  const fund2Onchange = (searchedVal) => {
    const filteredvalue = secLvlDetails4.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails2(secLvlDetails4);
    } else {
      setFilteredDetails2(filteredvalue);
    }
  };
  useEffect(() => {
    FundStatusDropdown();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const BackBotton = () => {
    navigate("/fund1stlvlvrfy");
  };
  const ForwordBotton = () => {
    navigate("/fundallocation");
  };
  return (
    <div>
      <Home />
      <Snackbar
        open={open}
        message={message}
        severity={severit}
        onClose={handleClose}
      />
      <div
        style={{
          paddingLeft: "80px",
          transition: "1s",
          transitionDelay: "revert-layer",
        }}
      >
        <Row>
          <Col xs={1}>
            <ToggleButton
              onClick={BackBotton}
              className="headerstyleStrt"
              size="small"
            >
              <ArrowBackIosIcon
                fontSize="small"
                style={{
                  fontSize: "16px",
                  marginLeft: "5px",
                  color: "red",
                  fontWeight: "bold",
                }}
              />{" "}
            </ToggleButton>
          </Col>
          <Col xs={10}></Col>
          <Col xs={1} style={{ textAlign: "end" }}>
            {" "}
            <ToggleButton
              onClick={ForwordBotton}
              className="headerstyleEND"
              size="small"
            >
              <ArrowForwardIosIcon
                fontSize="small"
                style={{ fontSize: "16px", color: "red", fontWeight: "bold" }}
              />{" "}
            </ToggleButton>
          </Col>
        </Row>
        <Grid2 container>
          <Box style={{ width: "11.5%" }}>
            <Item1>
              {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
              <lable
                style={{
                  fontFamily: "Times New Roman",
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                NonSecondLevelJob
              </lable>
              <TableContainer
                sx={{ maxHeight: 300 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.map((trns) => {
                      const isItemSelected = isSelected(trns.consignmentNumber);
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.consignmentNumber}
                          onClick={() => getnonpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item1>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{
                  fontFamily: "Times New Roman",
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Non Second Level Verify Purpose
              </lable>
              <TableContainer
                sx={{ maxHeight: 300 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{ width: "10px", textAlign: "center" }}
                      >
                        Sl
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ textAlign: "center", width: "100px" }}
                      >
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ width: "40px", textAlign: "center" }}
                      >
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {secLvlDetails2.map((trns) => {
                      const isItemSelected = isNonReqItemSelected(
                        trns.reqAmount
                      );
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.reqAmount}
                          onClick={() => nonverifypurpose(trns)}
                        >
                          <StyledTableCell style={{ color: "darkblue" }}>
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell style={{ color: "darkblue" }}>
                            {trns.reqPurpose}
                          </StyledTableCell>
                          <StyledTableCell style={{ color: "darkblue" }}>
                            {trns.reqAmount}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "37%" }}>
            <Item>
              <div
                style={{
                  fontFamily: "Times New Roman",
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginTop: "2%",
                }}
              >
                <center>FUND SECOND LEVEL VERIFICATION</center>
              </div>
              <Csscontrol
                fullWidth
                size="small"
                style={{ width: "35%", marginTop: "4%" }}
              >
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Fund Status
                </InputLabel>
                <Select
                  id="fundstatus"
                  label="Fund Statusss"
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onChange={SecLevelFundStatusHandleChange}
                  value={Fund2ndLvlvrfyvalues.fundstatus}
                >
                  <MenuItem></MenuItem>
                  {fundstatusdrp.map((status) => (
                    <MenuItem value={status.requestStatus}>
                      {status.requestStatus}
                    </MenuItem>
                  ))}
                </Select>
              </Csscontrol>
              {!BeNoHidden && (
                <>
                  <CssTextField
                    size="small"
                    label="BE NO"
                    variant="outlined"
                    sx={{
                      input: {
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "13px",
                      },
                    }}
                    style={{ marginLeft: "2%", width: "35%", marginTop: "1%" }}
                    value={beNoValue}
                    onChange={(e) => setBeNoValue(e.target.value)}
                  />
                  <Button
                    size="small"
                    hidden={BeNoSearchHidden}
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: "1%", marginTop: "1%" }}
                    onClick={handleBeNoSearch}
                  >
                    {searchPros ? "Processing..." : "Search"}
                  </Button>
                </>
              )}

              <CssTextField
                hidden={JobHidden}
                size="small"
                style={{ marginLeft: "2%", width: "35%", marginTop: "4%" }}
                label="Job No"
                variant="outlined"
                sx={{
                  input: {
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "13px",
                  },
                }}
                type={"number"}
                onChange={SecLvl_jobNoHandleChange}
                value={Fund2ndLvlvrfyvalues.jobNo}
                onKeyDown={jobkeydown}
              />

              <Button
                hidden={searchbtnhidden}
                size="small"
                variant="contained"
                color="primary"
                style={{ marginTop: "4%", marginLeft: "1%" }}
                onClick={jobSearchBtn}
              >
                Search
              </Button>

              <Csscontrol
                hidden={VendorHidden}
                fullWidth
                size="small"
                style={{ marginLeft: "2%", width: "35%", marginTop: "4%" }}
              >
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Vendor Type
                </InputLabel>
                <Select
                  label="Vendor Typeeeee"
                  native
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onChange={SecLvl_vendortypHandleChange}
                  value={Fund2ndLvlvrfyvalues.vendorType}
                >
                  <option></option>
                  {Vendordrp.map((trns) => (
                    <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                  ))}
                </Select>
              </Csscontrol>

              <div hidden={designHidden}>
                <Row className="mt-4">
                  <Col xs={7}>
                    <InputLabel
                      style={{
                        fontFamily: "Times New Roman",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                      }}
                    >
                      Request Amount :
                    </InputLabel>
                  </Col>
                  <Col
                    xs={3}
                    style={{
                      fontFamily: "Times New Roman",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                    }}
                  >
                    {Fund2ndLvlvrfyvalues.Reqamt}
                  </Col>
                </Row>
                <Row>
                  <Col xs={7}>
                    <InputLabel
                      style={{
                        fontFamily: "Times New Roman",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                      }}
                    >
                      Approval Amount :
                    </InputLabel>
                  </Col>
                  <Col
                    xs={3}
                    style={{
                      fontFamily: "Times New Roman",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                    }}
                  >
                    {Fund2ndLvlvrfyvalues.Aprvlamt}
                  </Col>
                </Row>
                <Row>
                  <Col
                    xs={7}
                    style={{
                      fontFamily: "Times New Roman",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    First Level Verified Amount :
                  </Col>
                  <Col
                    xs={3}
                    style={{
                      fontFamily: "Times New Roman",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                    }}
                  >
                    {Fund2ndLvlvrfyvalues.FirstLvlamt}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <CssTextField
                      type={"number"}
                      size="small"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      label="2nd Lvl Vr.Amt"
                      style={{ width: "90%" }}
                      id="2ndlvlamt"
                      variant="outlined"
                      required
                      onChange={SecLvl_amtHandleChange}
                      value={Fund2ndLvlvrfyvalues.secLvlAmt}
                      onKeyDown={fund2ndlvlKeydown}
                    />
                  </Col>
                  <Col>
                    <Csscontrol
                      style={{ width: "90%" }}
                      fullWidth
                      size="small"
                      onKeyDown={paymentMdkeydown}
                      required
                    >
                      <InputLabel
                        id="demo-select-small"
                        style={{
                          fontFamily: "Times New Roman",
                          fontWeight: "bold",
                        }}
                      >
                        Payment Mode
                      </InputLabel>
                      <Select
                        label="Payment Modeee"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                        InputLabelProps={{ shrink: true }}
                        id="paymentmode"
                        native
                        onChange={SecLvl_paymntmdHandleChange}
                        value={Fund2ndLvlvrfyvalues.paymentMode}
                      >
                        <option></option>
                        {PaymentModedrp.map((trns) => (
                          <option value={trns.paymentType}>
                            {trns.paymentType}
                          </option>
                        ))}
                      </Select>
                    </Csscontrol>
                  </Col>
                </Row>
                <CssTextField
                  size="small"
                  style={{ marginTop: "4%" }}
                  sx={{
                    input: {
                      fontFamily: "Times New Roman",
                      color: "black",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "13px",
                    },
                  }}
                  id="rmks"
                  label="2nd Lvl Vr.Remarks"
                  variant="outlined"
                  onChange={SecLvl_RmksHandleChange}
                  value={Fund2ndLvlvrfyvalues.secLevlRmks}
                />
              </div>
            </Item>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{
                  fontFamily: "Times New Roman",
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Second Level Verify Purpose
              </lable>
              <TableContainer
                className="scrollbarPrime"
                sx={{ maxHeight: 300 }}
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Sl
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Description
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {secLvlDetails3.map((trns) => {
                      const isItemSelected = isReqItemSelected(trns.reqAmount);
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.reqPurpose}
                          onClick={() => verifypurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqPurpose}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqAmount}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "11.5%" }}>
            <Item2>
              <div style={{ textAlign: "end" }}>
                <lable
                  style={{
                    fontFamily: "Times New Roman",
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "red",
                  }}
                >
                  SecondLevelVrfyJob
                </lable>
                {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
              </div>
              <TableContainer
                sx={{ maxHeight: 300 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch2()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails2.map((trns) => {
                      const isItemSelected = isReqjobSelected(
                        trns.consignmentNumber
                      );
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.consignmentNumber}
                          onClick={() => getpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item2>
          </Box>
        </Grid2>
        <center hidden={designHidden}>
          {" "}
          <div className="mt-2 mb-1 form-inline">
            <Button
              size="small"
              variant="contained"
              color="primary"
              className="mt-1"
              style={{ fontFamily: "Times New Roman" }}
              disabled={verifyDis}
              onClick={verifyBtn}
            >
              {verifyProcs ? "processing..." : "VERIFY"}
            </Button>{" "}
            <Button
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              style={{ fontFamily: "Times New Roman" }}
              disabled={updateDis}
              onClick={updateBtn}
            >
              {updateProcs ? "processing..." : "UPDATE"}
            </Button>{" "}
            <Button
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              style={{ fontFamily: "Times New Roman" }}
              disabled={NonverifyDis}
              onClick={NonverifyBtn}
            >
              {NonVerifyProcs ? "processing..." : "NON VERIFY"}
            </Button>{" "}
            <Button
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              style={{ fontFamily: "Times New Roman" }}
              disabled={DownldRqstDis}
              onClick={saveimage}
            >
              {dwnldRqCopyProcs ? "processing..." : "Download Request Copy"}
            </Button>{" "}
            <Button
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              style={{ fontFamily: "Times New Roman" }}
              onClick={RefreshBtn}
            >
              {RefreshProcs ? "processing..." : "REFRESH"}
            </Button>
          </div>
        </center>
        <Item hidden={tablehidden}>
          <TableContainer sx={{ maxHeight: 215 }} className="scrollbarPrime">
            <Table stickyHeader className="table table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Sl
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Description
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Request_Date
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2nd_ApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedBY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Release_BY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedBY
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {secLvlDetails5.map((trns) => (
                  <TableRow hover key={trns.reqPurpose}>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.serialNumber}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqPurpose}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalAmunt}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.appRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.release_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_amount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_remarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audited_by}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Item>
      </div>
    </div>
  );
}

export default FundSecLevelVerification;
